
<div class="p-3">
  <ng-content></ng-content>

  <div mat-dialog-actions class="d-flex justify-content-end mt-3">
    <shared-button-loader #primaryButtonLoader (loadingStarted)="onPrimaryButtonClick()"
    [buttonClass]="'btn btn-levelab'">
    {{ primaryButtonText }}
    </shared-button-loader>

    <shared-button-loader #secondaryButtonLoader (loadingStarted)="onSecondaryButtonClick()"
    [buttonClass]="'btn btn-outline-levelab'" *ngIf="showSecondaryButton">
    {{ secondaryButtonText }}
    </shared-button-loader>

  </div>

</div>
